module.exports = __webpack_public_path__ + "minecraftmarketingwp9b165d6ab3f0fc39cab7507fc0e0abf7.png";